// extracted by mini-css-extract-plugin
module.exports = {"fadeOut":"Effects-module--fadeOut--1N9PK","fadeIn":"Effects-module--fadeIn--1LD9t"};